import { Measure, Unit } from "convert-units";

export type AngleUnits = AngleMetricUnits | AngleImperialUnits;
export type AngleSystems = "metric" | "imperial";

export type AngleMetricUnits = "rad";
export type AngleImperialUnits = "deg";

const metric: Record<AngleMetricUnits, Unit> = {
  rad: {
    name: {
      singular: "",
      plural: "",
    },
    to_anchor: 1,
  },
};

const imperial: Record<AngleImperialUnits, Unit> = {
  deg: {
    name: {
      singular: "",
      plural: "",
    },
    to_anchor: 1,
  },
};

const measure: Measure<AngleSystems, AngleUnits> = {
  systems: {
    metric,
    imperial,
  },
  anchors: {
    metric: {
      imperial: {
        ratio: 57.295_78,
      },
    },
    imperial: {
      metric: {
        ratio: 0.017_453_29,
      },
    },
  },
};

export default measure;
